var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"yandex-map",attrs:{"id":"map"}}),_c('div',{staticClass:"custom-controls"},[_c('button',{staticClass:"control-button",on:{"click":_vm.zoomIn}},[_vm._v("+")]),_c('button',{staticClass:"control-button",on:{"click":_vm.zoomOut}},[_vm._v("-")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }